import React, { useState } from 'react';
import { Projects, Services } from './Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n';

const MobileHeader = () => {
  const [activeMenu, setActiveMenu] = useState('');
  const activeMenuSet = (value) =>
      setActiveMenu(activeMenu === value ? '' : value),
    activeLi = (value) =>
      value === activeMenu ? { display: 'block' } : { display: 'none' };
  return (
    <ul className="navigation clearfix d-block d-lg-none mobile-header">
      <li>
        <LocalizedLink to="/about/">O nas</LocalizedLink>
      </li>
      <li className="dropdown">
        <LocalizedLink to="/#services">Oferta</LocalizedLink>
        <ul style={activeLi('Services')}>
          <Services />
        </ul>
        <div className="dropdown-btn" onClick={() => activeMenuSet('Services')}>
          <span>
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </div>
      </li>
      <li className="dropdown">
        <LocalizedLink to="/#projects">Realizacje</LocalizedLink>
        <ul style={activeLi('Projects')}>
          <Projects />
        </ul>
        <div className="dropdown-btn" onClick={() => activeMenuSet('Projects')}>
          <span>
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </div>
      </li>
      <li>
        <LocalizedLink to="/career/">Kariera</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/contact/">Kontakt</LocalizedLink>
      </li>
      <li>
        <LocalizedLink to="/blog/">Blog</LocalizedLink>
      </li>
    </ul>
  );
};

export default MobileHeader;
